import { useQuery } from "@apollo/client";
import { FiltersState, filtersToWhere } from "src/components/Filter";
import constants from "src/constants";
import graphQLClient from "src/graphQL";
import { lectures } from "src/queries/lectures";

const defaultWhere = {
  blocked: false,
  private: false,
};

let customList = [
  ...constants.List.hpSeries,
  ...constants.List.hpClasses,
  ...constants.List.hpFestivals,
];

const homepageWhere = {
  blocked: false,
  private: false,
  id: customList,
};

export default function useGetDataSeriesAndClasses(
  filtersState: FiltersState,
  query?: string,
  skip?: boolean,
  hp?: boolean
) {
  const where = filtersToWhere(filtersState);
  return useQuery(lectures, {
    variables: {
      where: {
        ...where,
        ...(hp ? homepageWhere : defaultWhere),
        ...(query ? { _q: query } : {}),
      },
      sort: filtersState.sort,
    },
    errorPolicy: "all",
    skip,
  });
}

export async function getDataSeriesAndClasses() {
  const res = await graphQLClient.query({
    query: lectures,
    variables: { sort: "rating:desc", where: { ...defaultWhere } },
    errorPolicy: "all",
  });

  return res.data;
}
